let activeEnv = process.env.ACTIVE_ENV || process.env.NODE_ENV || "development"
let productionP = activeEnv === "production";

module.exports = {
  siteTitle: 'Trade Digitalisation Services - powered by China Systems', // <title>
  description: "In response to current market needs and the rapidly evolving global trade landscape, China Systems has created the specialised Trade Digitalisation Services (TDS), which is composed of experts who have deep technical, project and business domain knowledge on International Trade operations.We have previously been involved in a number of integration projects that were all delivered in record time with high quality, including integration with solutions such as Trade DLT platform Contour, Traydstream's OCR/AI Document Checking platform, Enigio's trace:original Digital Document technology and CargoX's Platform for Blockchain Document Transfer (including eBLs).",
  logo: 'src/assets/img/logo.png',
  manifestName: 'tds',
  manifestShortName: 'TDS', // max 12 characters
  manifestStartUrl: 'https://tds.chinasystems.com',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/favicon.png',
  pathPrefix: productionP?`/tds`:'', 
  heading: 'Trade Digitalisation Services',
  subHeading: 'Transforming Digital Opportunities into Reality',
  url: productionP?'https://cseu.chinasystems.com':'http://127.0.0.1:8000',
  keywords: "trade, digital documents",
  // social
  socialLinks: [
   
    {
      icon: ['fab', 'linkedin-in'],
      name: 'Linkedin',
      url: 'https://www.linkedin.com/company/china-systems/',
    },
    {
      icon: ['fab', 'youtube'],
      name: 'Youtube',
      url: 'https://www.youtube.com/channel/UCBegRTF_aI5g3xis6M-EqDQ',
    },
    {
      icon: ['fas', 'link'],
      name: 'China Systems',
      url: 'https://www.chinasystems.com',
    },
    
  ],
  email: 'tds@chinasystems.com',
  phone: '000-00000',
};
